import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { Typography } from '@finam/web-ui-kit';
import { DoneSmall } from '@finam/web-ui-kit/Icons/Action';
import styled from 'styled-components';
export var Root = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export var Icon = styled(DoneSmall).attrs({
  color: 'disabled'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &.enabled {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.label.positive;
});
export var Text = styled(Typography).attrs({
  variant: 'caption12',
  color: 'disabled'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 4px 0;\n  margin-left: 12px;\n  &.enabled {\n    color: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.label.positive;
});